import { PrimaryDefaultButton } from '@/components/buttons/primary';
import { COLORS } from '@/styles/color';
import styled from 'styled-components';

interface FrontPinkButtonProps {
  inverted?: boolean;
}

const FrontPinkButton = styled(PrimaryDefaultButton) <FrontPinkButtonProps>`
  --button-color: ${({ inverted }) => (inverted ? COLORS.WHITE : COLORS.VIOLET.BASE)};
  --button-text-color: ${({ inverted }) => (inverted ? COLORS.BLACK : COLORS.WHITE)};


  &:hover {
    background-color: ${({ inverted }) => (inverted ? COLORS.WHITE : COLORS.VIOLET.LOWLIGHT)};
  }
`;

export default FrontPinkButton;
